import type React from 'react';
import { OverviewCard } from './OverviewCard';
import { OverviewEmptyBody } from './OverviewEmptyBody';

type OverviewEmptyCardProps = {
    /** Literal testid prefix, e.g. `cash-runway`. */
    slot: string;
    icon: string;
    title: string;
    question: string;
    body: string;
    cta: { label: string; icon: string; onPress: () => void };
};

/**
 * A card in its empty state — identical in shape for all four metrics, which is
 * the point: the header and the frame are exactly what the filled card shows,
 * so nothing moves when the figures arrive. Only the middle is swapped, for the
 * sentence saying what is missing and the action that supplies it.
 *
 * No tone and no delta: a metric with no inputs is not doing badly, and it has
 * not moved.
 */
export const OverviewEmptyCard: React.FC<OverviewEmptyCardProps> = ({
    slot,
    icon,
    title,
    question,
    body,
    cta,
}) => (
    <OverviewCard
        icon={icon}
        question={question}
        slot={slot}
        title={title}
        tone={null}
    >
        <OverviewEmptyBody body={body} cta={cta} slot={slot} />
    </OverviewCard>
);
